<template>
  <v-container>
    <v-row
      ><v-col cols="0" lg="0" xl="1"></v-col
      ><v-col cols="12" lg="12" xl="10">
        <v-data-table
          id="storeTable"
          ref="vDataTable"
          v-model="selected"
          :headers="headers"
          :items="desserts"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :search="search"
          item-key="createTime"
          show-expand
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar
              :flat="offsetTop <= 0"
              style="
                position: sticky;
                top: 73px;
                background-color: #fff;
                z-index: 1;
              "
            >
              <v-toolbar-title>商店樣板</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog persistent v-model="dialog" max-width="1900px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue-grey"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    新增
                  </v-btn>
                  <!-- <v-btn
                    color="blue-grey lighten-1"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2 mr-2"
                    @click="next()"
                    v-if="lastVisible"
                  >
                    載入更多
                  </v-btn> -->
                  <!-- <v-btn
                    color="blue-grey lighten-1"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mr-2 mt-2"
                    @click="expiredVerification"
                    ><v-icon dark left class="mr-1"> mdi-restore </v-icon>
                    過期驗證 </v-btn
                  ><v-btn
                    color="blue-grey lighten-2"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2 mr-2"
                    @click="exportExcel()"
                  >
                    匯出 Excel </v-btn
                  > -->
                  <!-- <v-spacer> </v-spacer
                  ><v-btn
                    color="blue-grey lighten-2"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2"
                    @click="(actTypesFilter = ''), (expiredFilter = '')"
                  >
                    清除 </v-btn
                  ><v-select
                    v-model="expiredFilter"
                    class="mr-2"
                    style="width: 10px"
                    :items="expireds"
                    label="過期"
                    hide-details="true"
                    persistent-hint
                    dense
                    outlined
                    required
                    single-line
                  ></v-select
                  ><v-select
                    v-model="actTypesFilter"
                    class="mr-2"
                    style="width: 10px"
                    :items="actTypes"
                    item-text="actTypeName"
                    item-value="actTypeId"
                    label="分類"
                    hide-details="true"
                    persistent-hint
                    dense
                    outlined
                    required
                    single-line
                  ></v-select> -->
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </template>
                <v-card>
                  <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="close()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text class="pt-6">
                    <v-container fluid>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="12" md="6">
                                <v-img
                                  :lazy-src="
                                    template.logoUrl
                                      ? template.logoUrl
                                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                  "
                                  max-height="154"
                                  :src="
                                    template.logoUrl
                                      ? template.logoUrl
                                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                  "
                                ></v-img>
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-text-field
                                  v-model="template.logoUrl"
                                  class="mb-6"
                                  label="商標網址"
                                  hide-details="true"
                                  dense
                                  outlined
                                ></v-text-field>
                                <div
                                  class="d-flex justify-space-between flex-wrap"
                                >
                                  <v-btn
                                    depressed
                                    color="cyan lighten-1"
                                    class="white--text mb-4"
                                    style="
                                      min-width: 50px;
                                      width: 100%;
                                      padding: 0 10px;
                                      height: 38px;
                                    "
                                    @click="
                                      upLoadingImg = 'logo';
                                      showUploadImg();
                                    "
                                  >
                                    上傳
                                  </v-btn>
                                  <v-btn
                                    depressed
                                    color="grey"
                                    class="white--text"
                                    style="
                                      min-width: 50px;
                                      width: 100%;
                                      padding: 0 10px;
                                      height: 38px;
                                    "
                                    @click="template.logoUrl = ''"
                                  >
                                    清除
                                  </v-btn>
                                </div>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-row>
                              <v-col cols="12" md="6">
                                <v-row>
                                  <v-col cols="12" md="4">
                                    <v-select
                                      v-model="template.actType"
                                      :items="actTypes"
                                      item-text="actTypeName"
                                      item-value="actTypeId"
                                      label="*分類"
                                      hide-details="true"
                                      persistent-hint
                                      dense
                                      outlined
                                      required
                                      :rules="[(v) => !!v]"
                                    ></v-select>
                                  </v-col>
                                  <v-col cols="12" md="8">
                                    <v-text-field
                                      v-model="template.title"
                                      :counter="10"
                                      label="*活動名稱"
                                      hide-details="true"
                                      dense
                                      outlined
                                      required
                                      :rules="[(v) => !!v]"
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" md="12">
                                    <v-textarea
                                      v-model="template.description"
                                      label="*介紹"
                                      hide-details="true"
                                      dense
                                      outlined
                                      required
                                      rows="3"
                                      :rules="[(v) => !!v]"
                                    ></v-textarea>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-row>
                                  <v-col cols="12" md="4">
                                    <v-menu
                                      v-model="startTimeMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="auto"
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-text-field
                                          v-model="template.startDate"
                                          label="*起始日期"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                          dense
                                          outlined
                                          hide-details="true"
                                          required
                                          :rules="[(v) => !!v]"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="template.startDate"
                                        no-title
                                        @input="startTimeMenu = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <v-menu
                                      v-model="endTimeMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="auto"
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-text-field
                                          v-model="template.endDate"
                                          label="*結束日期"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                          dense
                                          outlined
                                          required
                                          hide-details="true"
                                          :disabled="!template.startDate"
                                          :rules="
                                            dateRules(
                                              template.endDate,
                                              template.startDate
                                            )
                                          "
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="template.endDate"
                                        no-title
                                        @input="endTimeMenu = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <v-select
                                      v-model="template.expired"
                                      :items="expireds"
                                      label="*過期"
                                      hide-details="true"
                                      persistent-hint
                                      dense
                                      outlined
                                    ></v-select>
                                  </v-col>
                                  <v-col cols="12" md="12">
                                    <v-textarea
                                      v-model="template.memo"
                                      label="備註"
                                      hide-details="true"
                                      dense
                                      outlined
                                      required
                                      rows="3"
                                    ></v-textarea>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col cols="12" class="py-0">
                            <v-divider class="mt-3 mb-1"></v-divider>
                            <v-divider class="mb-4"></v-divider>
                          </v-col>

                          <v-col
                            cols="12"
                            class="my-scrollbar"
                            style="
                              max-height: calc(100vh - 490px);
                              overflow: auto;
                            "
                          >
                            <v-row class="store-template-bg">
                              <v-col
                                cols="12"
                                v-for="(
                                  item, index
                                ) in template.customAttributes"
                                :key="index"
                              >
                                <v-row>
                                  <v-col cols="12" md="4">
                                    <v-row>
                                      <v-col cols="12" md="6">
                                        <v-img
                                          :lazy-src="
                                            item.mainPictureUrl
                                              ? item.mainPictureUrl
                                              : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                          "
                                          height="104"
                                          :src="
                                            item.mainPictureUrl
                                              ? item.mainPictureUrl
                                              : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                          "
                                        ></v-img>
                                      </v-col>
                                      <v-col cols="12" md="6">
                                        <v-text-field
                                          v-model="item.mainPictureUrl"
                                          class="mb-6"
                                          label="主圖網址"
                                          hide-details="true"
                                          dense
                                          outlined
                                        ></v-text-field>
                                        <div
                                          class="d-flex justify-space-between"
                                        >
                                          <v-btn
                                            depressed
                                            color="orange lighten-1"
                                            class="white--text"
                                            style="
                                              min-width: 50px;
                                              width: 49%;
                                              padding: 0 10px;
                                            "
                                            @click="
                                              upLoadingImg = 'mainPicture';
                                              upLoadingImgActive = index;
                                              showUploadImg();
                                            "
                                          >
                                            上傳
                                          </v-btn>
                                          <v-btn
                                            depressed
                                            color="grey"
                                            class="white--text"
                                            style="
                                              min-width: 50px;
                                              width: 49%;
                                              padding: 0 10px;
                                            "
                                            @click="item.mainPictureUrl = ''"
                                          >
                                            清除
                                          </v-btn>
                                        </div>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" md="6">
                                        <v-img
                                          :lazy-src="
                                            item.subPictureUrl
                                              ? item.subPictureUrl
                                              : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                          "
                                          height="104"
                                          :src="
                                            item.subPictureUrl
                                              ? item.subPictureUrl
                                              : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                          "
                                        ></v-img>
                                      </v-col>
                                      <v-col cols="12" md="6">
                                        <v-text-field
                                          v-model="item.subPictureUrl"
                                          class="mb-6"
                                          label="副圖網址"
                                          hide-details="true"
                                          dense
                                          outlined
                                        ></v-text-field>
                                        <div
                                          class="d-flex justify-space-between"
                                        >
                                          <v-btn
                                            depressed
                                            color="orange lighten-1"
                                            class="white--text"
                                            style="
                                              min-width: 50px;
                                              width: 49%;
                                              padding: 0 10px;
                                            "
                                            @click="
                                              upLoadingImg = 'subPicture';
                                              upLoadingImgActive = index;
                                              showUploadImg();
                                            "
                                          >
                                            上傳
                                          </v-btn>
                                          <v-btn
                                            depressed
                                            color="grey"
                                            class="white--text"
                                            style="
                                              min-width: 50px;
                                              width: 49%;
                                              padding: 0 10px;
                                            "
                                            @click="item.subPictureUrl = ''"
                                          >
                                            清除
                                          </v-btn>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12" md="8">
                                    <v-row>
                                      <v-col cols="12" md="6">
                                        <v-row
                                          ><v-col cols="12" md="12">
                                            <v-text-field
                                              v-model="item.storeName"
                                              label="*店名"
                                              hide-details="true"
                                              dense
                                              outlined
                                              required
                                              :rules="[(v) => !!v]"
                                            ></v-text-field>
                                          </v-col>
                                          <v-col cols="12" md="12">
                                            <v-text-field
                                              v-model.trim="item.phone"
                                              label="*電話"
                                              hide-details="true"
                                              dense
                                              outlined
                                              required
                                              :rules="[(v) => !!v]"
                                            ></v-text-field>
                                          </v-col>

                                          <v-col cols="12" md="4">
                                            <v-select
                                              v-model="item.city"
                                              :items="citys"
                                              item-text="cityName"
                                              item-value="cityId"
                                              label="*縣市"
                                              hide-details="true"
                                              persistent-hint
                                              dense
                                              outlined
                                              required
                                              :rules="[(v) => !!v]"
                                            ></v-select>
                                          </v-col>
                                          <v-col cols="12" md="8">
                                            <v-text-field
                                              v-model.trim="item.address"
                                              label="*地址"
                                              hide-details="true"
                                              dense
                                              outlined
                                              required
                                              :rules="[(v) => !!v]"
                                            ></v-text-field>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="12" md="6">
                                        <v-row>
                                          <v-col cols="12" md="12">
                                            <v-row>
                                              <v-col cols="12" md="12">
                                                <v-text-field
                                                  v-model.trim="item.webSiteUrl"
                                                  label="*官網"
                                                  hide-details="true"
                                                  dense
                                                  outlined
                                                  required
                                                  :rules="[(v) => !!v]"
                                                ></v-text-field> </v-col
                                              ><v-col cols="12" md="4">
                                                <v-text-field
                                                  v-model="item.storeNo"
                                                  label="商店編號"
                                                  hide-details="true"
                                                  dense
                                                  outlined
                                                  readonly
                                                  disabled
                                                ></v-text-field> </v-col
                                              ><v-col cols="12" md="4">
                                                <v-select
                                                  v-model="item.storeIsInGroup"
                                                  :items="storeIsInGroups"
                                                  label="集團代表"
                                                  hide-details="true"
                                                  persistent-hint
                                                  dense
                                                  outlined
                                                ></v-select>
                                              </v-col>
                                              <v-col cols="12" md="4">
                                                <v-text-field
                                                  v-model="item.groupId"
                                                  label="集團代碼"
                                                  hide-details="true"
                                                  dense
                                                  outlined
                                                  required
                                                ></v-text-field>
                                              </v-col>

                                              <v-col cols="12" md="4">
                                                <v-text-field
                                                  v-model.number="item.lat"
                                                  label="*緯度(lat)"
                                                  hide-details="true"
                                                  dense
                                                  outlined
                                                  required
                                                  :rules="[(v) => !!v]"
                                                ></v-text-field>
                                              </v-col>
                                              <v-col cols="12" md="4">
                                                <v-text-field
                                                  v-model.number="item.lng"
                                                  label="*經度(lng)"
                                                  hide-details="true"
                                                  dense
                                                  outlined
                                                  required
                                                  :rules="[(v) => !!v]"
                                                ></v-text-field>
                                              </v-col>
                                              <v-col cols="12" md="4">
                                                <v-select
                                                  v-model="item.display"
                                                  :items="displays"
                                                  label="是否顯示"
                                                  hide-details="true"
                                                  persistent-hint
                                                  dense
                                                  outlined
                                                ></v-select>
                                              </v-col>
                                            </v-row>
                                          </v-col>
                                          <!-- <v-col cols="12" md="4">
                                        <v-row
                                          ><v-col cols="12" md="12">
                                            <div
                                              class="d-flex justify-space-between align-center"
                                            >
                                              <v-btn
                                                depressed
                                                color="red"
                                                class="white--text w-100"
                                                @click="
                                                  dialogDeleteBranch = true;
                                                  catchDeleteBranchIndex =
                                                    index;
                                                "
                                              >
                                                移除分店
                                              </v-btn>
                                            </div>
                                          </v-col></v-row
                                        >
                                      </v-col> -->
                                        </v-row>
                                      </v-col>
                                      <v-col cols="12" md="12">
                                        <v-btn
                                          depressed
                                          block
                                          color="red"
                                          class="white--text w-100"
                                          @click="
                                            dialogDeleteBranch = true;
                                            catchDeleteBranchIndex = index;
                                          "
                                        >
                                          移除分店
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-col>

                                  <v-col cols="12">
                                    <v-divider></v-divider>
                                  </v-col>
                                </v-row> </v-col
                            ></v-row>
                          </v-col>

                          <v-col>
                            <v-btn
                              depressed
                              color="cyan lighten-1"
                              class="white--text w-100"
                              block
                              style="width: 75px"
                              @click="
                                template.customAttributes.push(
                                  Object.assign({}, storeTemplate)
                                );
                                $snackbar.add(`新增成功`, { color: 'success' });
                              "
                            >
                              新增分店
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close()">
                      取消
                    </v-btn>
                    <!-- <v-btn
                      color="blue darken-1"
                      text
                      v-if="editedIndex != -1"
                      @click="saveAs"
                    >
                      另存新檔
                    </v-btn> -->
                    <v-btn color="blue darken-1" text @click="save()">
                      儲存
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save(true)">
                      同步至商店
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 justify-center"
                    >確定要移除
                    <span class="d-inline-block mx-2" style="color: #ff5252">{{
                      template.storeName
                    }}</span>
                    ?</v-card-title
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue-grey lighten-1"
                      outlined
                      depressed
                      @click="closeDelete"
                      >取消</v-btn
                    >
                    <v-btn
                      color="blue-grey lighten-1"
                      dark
                      depressed
                      @click="deleteItemConfirm"
                      >確認</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.address`]="{ item }">
            {{ item.address.trim().substr(0, 40) }}
          </template>
          <template v-slot:[`item.actType`]="{ item }">
            {{
              actTypes.filter(function (mapItem, index, array) {
                return mapItem.actTypeId === item.actType;
              })[0]["actTypeName"]
            }}
          </template>
          <template v-slot:[`item.expired`]="{ item }">
            <v-simple-checkbox
              v-model="item.expired"
              :ripple="false"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.actionsEdit`]="{ item }">
            <v-icon @click="editItem(item)" style="font-size: 19px">
              mdi-pencil
            </v-icon>
            <!--<v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>-->
          </template>
          <template v-slot:[`item.actionsDel`]="{ item }">
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template v-slot:[`item.data-table-expand`]="props">
            <v-icon
              :class="{
                'v-data-table__expand-icon': true,
                'v-data-table__expand-icon--active':
                  props.isExpanded && transitioned[getItemId(props.item)],
              }"
              @click="toggleExpand(props)"
            >
              mdi-chevron-down
            </v-icon>
          </template>
          <template v-slot:[`item.display`]="{ item }">
            <v-simple-checkbox
              v-model="item.display"
              class="ml-3"
              :ripple="false"
              disabled
            ></v-simple-checkbox>
          </template>
          <!--展開內容-->
          <template v-slot:[`expanded-item`]="{ headers, item }">
            <td
              :colspan="headers.length"
              :class="{
                'ma-0 pa-0': true,
                'expanded-closing': !transitioned[getItemId(item)],
              }"
              style="height: auto"
            >
              <v-expand-transition>
                <div v-show="transitioned[getItemId(item)]">
                  <div class="pa-2" style="min-height: 100px">
                    <!--<span>{{ item }}</span>-->
                    <v-form>
                      <v-container class="my-6">
                        <v-row
                          v-for="(customStore, index) in item.customAttributes"
                          :key="index"
                        >
                          <v-col cols="12" md="2">
                            <v-img
                              style="
                                filter: grayscale(0);
                                width: 98%;
                                max-width: 1000px;
                              "
                              :lazy-src="
                                customStore.mainPictureUrl
                                  ? customStore.mainPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              :src="
                                customStore.mainPictureUrl
                                  ? customStore.mainPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              cover
                            ></v-img>
                          </v-col>
                          <v-col cols="12" md="10">
                            <div class="d-flex justify-space-between">
                              <div>
                                <div
                                  class="grey--text text--darken-1 text-subtitle-2 mb-2 font-weight-regular"
                                >
                                  {{ customStore.address }}
                                </div>
                                <p
                                  class="text-h4 font-weight-black text--primary mb-1"
                                >
                                  {{ customStore.title }}
                                </p>
                                <!-- <div
                                  class="font-weight-black font-weight-medium grey--text text--darken-2 text-h6 mb-10"
                                >
                                  {{
                                    citys.filter(function (
                                      mapItem,
                                      index,
                                      array
                                    ) {
                                      return (
                                        mapItem.cityId === item.city
                                      );
                                    })[0]["cityName"]
                                  }}
                                </div> -->
                              </div>
                              <div>
                                <v-img
                                  max-width="70"
                                  class="mb-2"
                                  style="opacity: 0.8"
                                  :lazy-src="
                                    item.logoUrl
                                      ? item.logoUrl
                                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                  "
                                  :src="
                                    item.logoUrl
                                      ? item.logoUrl
                                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                  "
                                ></v-img>
                              </div>
                            </div>
                            <hr
                              class="v-divider theme--light border-dashed mb-4"
                              style="border-style: dashed"
                            />
                            <v-row>
                              <v-col cols="12"
                                ><v-row no-gutters>
                                  <v-col cols="12" md="2">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      集團代碼
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2"
                                    >
                                      {{ customStore.groupId }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="2">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      商店編號
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2"
                                    >
                                      {{ customStore.storeNo }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="2">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      電話
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2"
                                    >
                                      {{ customStore.phone }}
                                    </div> </v-col
                                  ><v-col cols="12" md="3">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      緯度
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2"
                                    >
                                      {{ customStore.lat }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="3">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      經度
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2"
                                    >
                                      {{ customStore.lng }}
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12" md="12" class="py-0">
                                <hr
                                  class="v-divider theme--light border-dashed mb-1"
                                  style="border-style: dashed"
                                />
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </div>
                </div>
              </v-expand-transition>
            </td>
          </template> </v-data-table></v-col
      ><v-col cols="0" lg="0" xl="1"></v-col
    ></v-row>
    <v-dialog
      v-model="dialog_showUploadImg"
      :width="upLoadingImg == 'logo' ? 860 : 860"
    >
      <v-toolbar color="primary" dark>
        <v-toolbar-title>上傳圖片</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog_showUploadImg = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <cropperDialogs
        @update="getImgFile"
        :cropRatio="upLoadingImg == 'logo' ? [1, 1] : [4, 3]"
        :cropWidth="upLoadingImg == 'logo' ? 500 : 600"
        v-if="dialog_showUploadImg"
      ></cropperDialogs>
    </v-dialog>
    <v-dialog v-model="dialogDeleteBranch" max-width="500px">
      <v-card v-if="catchDeleteBranchIndex || catchDeleteBranchIndex == 0">
        <v-card-title class="text-h5 justify-center"
          >確定要移除
          <span class="d-inline-block mx-2" style="color: #ff5252">{{
            template.customAttributes[catchDeleteBranchIndex].title
              ? template.customAttributes[catchDeleteBranchIndex].title
              : `第 ${catchDeleteBranchIndex + 1} 筆店家`
          }}</span>
          ?</v-card-title
        >
        <div class="text-center mb-1 blue-grey--text lighten-1--text">
          (注意:此處僅移除樣板資料，已同步的商店不受此處移除影響)
        </div>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            color="blue-grey lighten-1"
            outlined
            depressed
            @click="dialogDeleteBranch = false"
            >取消</v-btn
          >
          <v-btn
            color="blue-grey lighten-1"
            dark
            depressed
            @click="deleteBranchConfirm"
            >確認</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import ExcelJs from "exceljs";
import cropperDialogs from "@/components/cropperDialogs.vue";
import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import { db, storage } from "@/firebase";
import {
  query,
  where,
  collection,
  getDoc,
  getDocs,
  setDoc,
  doc,
  deleteDoc,
  updateDoc,
  // orderBy,
  // startAfter,
  // limit,
} from "firebase/firestore/lite";

export default {
  components: {
    cropperDialogs,
  },
  data: () => ({
    offsetTop: 0,
    actTypesFilter: "",
    expiredFilter: "",
    valid: true,
    dialog_showUploadImg: false,
    startTimeMenu: false,
    endTimeMenu: false,
    search: "",
    singleSelect: false,
    selected: [],
    expanded: [],
    singleExpand: false,
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "編號", value: "storeTemplateNo", width: "8%" },
      {
        text: "活動名稱",
        align: "start",
        sortable: false,
        value: "title",
        width: "30%",
      },
      // { text: "地址", value: "address", width: "20%" },
      {
        text: "分類",
        value: "actType",
        align: "center",
        width: "10%",
        sortable: false,
      },
      {
        text: "起始日期",
        value: "startDate",
        align: "center",
        sortable: false,
        width: "15%",
      },
      {
        text: "結束日期",
        value: "endDate",
        align: "center",
        sortable: false,
        width: "15%",
      },
      // {
      //   text: "過期",
      //   value: "expired",
      //   align: "center",
      //   width: "7%",
      // },
      // {
      //   text: "顯示",
      //   value: "display",
      //   align: "center",
      //   width: "7%",
      // },
      {
        text: "編輯",
        value: "actionsEdit",
        sortable: false,
        align: "center",
        width: "10%",
      },
      // {
      //   text: "刪除",
      //   value: "actionsDel",
      //   sortable: false,
      //   align: "center",
      //   width: "10%",
      // },
      {
        text: "展開",
        value: "data-table-expand",
        sortable: false,
        align: "center",
        width: "10%",
      },
    ],
    desserts: [
      // {
      //   subSiteUrl: "www.google.com",
      //   storeName: "新垣祖鍋物",
      //   actType: "30",
      //   description: "預定住宿請上官網",
      //   createTime: 1674116537,
      //   endDate: "2023-12-31",
      //   expired: false,
      //   logoUrl:
      //     "https://firebasestorage.googleapis.com/v0/b/pec-eps-4819c.appspot.com/o/stores%2FruOrWaojb76sLSQdsGNP%2FlogoFile.png?alt=media&token=c22a2eaa-2435-469c-94a0-ebd888fdedf8&quot",
      //   memo: "備註",
      //   startDate: "2023-01-01",
      //   groupId: "499",
      //   customAttributes: [
      //     {
      //       address: "806台南市安平區國平路206號",
      //       lng: "25.058797473730994",
      //       groupId: "499",
      //       display: true,
      //       count: 0,
      //       title: "新垣祖鍋物蘆洲分店",
      //       webSiteUrl:
      //         "https://firebasestorage.googleapis.com/v0/b/pec-eps-4819c.appspot.com/o/stores%2FahmzPG1V6udqObqOb9R7%2FmainPictureFile.jpeg?alt=media&token=68516861-7f93-4608-8fec-abc900f45ce4",
      //       city: "15",
      //       subPictureUrl: "",
      //       storeIsInGroup: false,
      //       storeNo: "499",
      //       mainPictureUrl:
      //         "https://firebasestorage.googleapis.com/v0/b/pec-eps-4819c.appspot.com/o/stores%2FahmzPG1V6udqObqOb9R7%2FmainPictureFile.jpeg?alt=media&token=68516861-7f93-4608-8fec-abc900f45ce4",
      //       phone: "06-1234567",
      //       lat: "25.058797473730994",
      //     },
      //     {
      //       address: "806台南市安平區國平路206號",
      //       lng: "25.058797473730994",
      //       groupId: "499",
      //       display: true,
      //       count: 0,
      //       title: "新垣祖鍋物鳳山分店",
      //       webSiteUrl: "",
      //       city: "15",
      //       subPictureUrl: "",
      //       storeIsInGroup: false,
      //       storeNo: "498",
      //       mainPictureUrl:
      //         "https://firebasestorage.googleapis.com/v0/b/pec-eps-4819c.appspot.com/o/stores%2FahmzPG1V6udqObqOb9R7%2FmainPictureFile.jpeg?alt=media&token=68516861-7f93-4608-8fec-abc900f45ce4",
      //       phone: "06-1234567",
      //       lat: "25.058797473730994",
      //     },
      //   ],
      // },
    ],
    citys: [],
    actTypes: [],
    expireds: [true, false],
    storeIsInGroups: [true, false],
    displays: [true, false],
    editedIndex: -1,
    defaultItem: {
      subSiteUrl: "",
      title: "",
      actType: "",
      description: "",
      createTime: 0,
      endDate: "",
      expired: "",
      logoUrl: "",
      memo: "",
      startDate: "",
      customAttributes: [
        {
          address: "",
          lng: "",
          groupId: "",
          display: false,
          count: 0,
          storeName: "",
          webSiteUrl: "",
          city: "",
          subPictureUrl: "",
          storeIsInGroup: false,
          storeNo: "尚未取號",
          mainPictureUrl: "",
          phone: "",
          lat: "",
        },
      ],
    },
    template: {
      subSiteUrl: "",
      title: "",
      actType: "",
      description: "",
      createTime: 0,
      endDate: "",
      expired: "",
      logoUrl: "",
      memo: "",
      startDate: "",
      customAttributes: [
        {
          address: "",
          lng: "",
          groupId: "",
          display: false,
          count: 0,
          storeName: "",
          webSiteUrl: "",
          city: "",
          subPictureUrl: "",
          storeIsInGroup: false,
          storeNo: "尚未取號",
          mainPictureUrl: "",
          phone: "",
          lat: "",
        },
      ],
    },
    synchronousTemplate: [],
    storeTemplate: {
      address: "",
      lng: "",
      groupId: "",
      display: false,
      count: 0,
      storeName: "",
      webSiteUrl: "",
      city: "",
      subPictureUrl: "",
      storeIsInGroup: false,
      storeNo: "尚未取號",
      mainPictureUrl: "",
      phone: "",
      lat: "",
    },
    transitioned: [],
    closeTimeouts: {},
    logoFile: null,
    mainPictureFile: [],
    subPictureFile: [],
    upLoadingImg: "",
    upLoadingImgActive: 0,
    lastVisible: {},
    dialogDeleteBranch: false,
    catchDeleteBranchIndex: null,
    allStrores: [],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
    // dessertsFilter() {
    //   let vm = this;
    //   if (this.expiredFilter && this.actTypesFilter) {
    //     return this.desserts.filter((item) => {
    //       return (
    //         item.expired == vm.expiredFilter &&
    //         item.actType == vm.actTypesFilter
    //       );
    //     });
    //   } else if (this.expiredFilter) {
    //     return this.desserts.filter((item) => {
    //       return item.expired == vm.expiredFilter;
    //     });
    //   } else if (this.actTypesFilter) {
    //     return this.desserts.filter((item) => {
    //       return item.actType == vm.actTypesFilter;
    //     });
    //   } else {
    //     return this.desserts;
    //   }
    // },
  },
  watch: {
    // dialog(val) {
    //   val || this.close();
    // },
    // dialogDelete(val) {
    //   val || this.closeDelete();
    // },
    singleExpand(v) {
      if (!v) return;
      // Single expand enabled. Hide all but the first expanded item
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
  },
  async created() {
    this.$bus.$emit("sideBarSelectedItem:push", 2);
    // this.template = JSON.parse(JSON.stringify(this.defaultItem));
    await this.getCitys();
    await this.getActTypes();
    await this.getStoreTemplates();
    // window.addEventListener("scroll", this.handleScroll);
    // console.log(await this.getStoreCount("1"));
  },

  methods: {
    async getUpdatedStoreNo() {
      try {
        // 指定集合和文件 ID
        const docRef = doc(db, "currentStoreNo", "currentStoreNo");
        // 取得文件
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          // 取得 currentStoreNo 的值，轉為數字並加一
          const currentStoreNoStr = docSnap.data().currentStoreNo;
          const currentStoreNo = parseInt(currentStoreNoStr, 10);
          const updatedStoreNo = currentStoreNo + 1;

          // 將更新後的值存回文件
          await updateDoc(docRef, {
            currentStoreNo: updatedStoreNo.toString(),
          });
          // console.log("更新後的 currentStoreNo:", updatedStoreNo);
          return updatedStoreNo.toString();
        }
      } catch (error) {
        console.error("Error updating document: ", error);
      }
    },
    async getStoreCount(storeNo) {
      try {
        // 指定要搜尋的集合名稱
        const storesCollection = collection(db, "stores");

        // 建立查詢條件，搜尋 storeNo 欄位等於 storeNo 的文件
        const q = query(storesCollection, where("storeNo", "==", storeNo));

        // 執行查詢
        const querySnapshot = await getDocs(q);

        // 處理查詢結果，返回第一個找到的文件的 count 值
        if (!querySnapshot.empty) {
          // 取得第一個文件
          const doc = querySnapshot.docs[0];
          // 返回 count 欄位的值
          return doc.data().count;
        } else {
          // 如果找不到符合條件的文件，返回 null 或其他預設值
          return 0;
        }
      } catch (error) {
        console.error("Error searching documents: ", error);
        // 如果發生錯誤，也可以返回 null 或其他錯誤表示值
        return null;
      }
    },
    showUploadImg() {
      this.dialog_showUploadImg = true;
    },
    getImgFile(file) {
      fetch(file)
        .then((res) => res.blob())
        .then((res) => {
          if (this.upLoadingImg == "logo") {
            this.template.logoUrl = URL.createObjectURL(res);
            this.logoFile = res;
          } else if (this.upLoadingImg == "mainPicture") {
            this.template.customAttributes[
              this.upLoadingImgActive
            ].mainPictureUrl = URL.createObjectURL(res);
            this.mainPictureFile[this.upLoadingImgActive] = res;
            console.log(this.mainPictureFile);
          } else if (this.upLoadingImg == "subPicture") {
            this.template.customAttributes[
              this.upLoadingImgActive
            ].subPictureUrl = URL.createObjectURL(res);
            this.subPictureFile[this.upLoadingImgActive] = res;
          }
          this.upLoadingImg = "";
          this.upLoadingImgActive = 0;
          this.dialog_showUploadImg = false;
        });
    },
    async getCitys() {
      const querySnapshot = await getDocs(collection(db, "city"));
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        this.citys.push(doc.data());
        this.citys.sort((a, b) => {
          return a.cityId - b.cityId;
        });
      });
    },
    async getActTypes() {
      let actTypes = null;
      let myActTypesKey = [];
      const querySnapshot = await getDocs(collection(db, "acttype"));
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data().act);
        actTypes = doc.data().act;
        myActTypesKey = Object.keys(actTypes);
        myActTypesKey.forEach((item) => {
          this.actTypes.push({
            actTypeId: actTypes[item][0],
            actTypeName: actTypes[item][1],
            actTypeUrl: actTypes[item][2],
          });
        });
        this.actTypes.sort((a, b) => {
          return a.actTypeId - b.actTypeId;
        });
      });
    },
    async getStoreTemplates() {
      const querySnapshot = await getDocs(collection(db, "storeTemplates"));
      querySnapshot.forEach((doc) => {
        this.desserts.push(doc.data());
        this.desserts.sort((a, b) => {
          return b.storeTemplateNo - a.storeTemplateNo;
        });
      });
      console.log("getStoreTemplates", this.desserts);
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = JSON.parse(JSON.stringify(item));
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = JSON.parse(JSON.stringify(item));
      this.dialogDelete = true;
    },
    deleteBranchConfirm() {
      if (this.template.customAttributes.length > 1) {
        this.dialogDeleteBranch = false;
        this.template.customAttributes.splice(this.catchDeleteBranchIndex, 1);
        this.catchDeleteBranchIndex = null;
        this.$snackbar.add(`刪除成功`, { color: "success" });
      } else {
        this.dialogDeleteBranch = false;
        this.catchDeleteBranchIndex = null;
        alert("請至少保留一間分店，如要移除整個項目請由外層移除");
      }
    },
    async deleteItemConfirm() {
      const q = query(
        collection(db, "storeTemplates"),
        where("storeTemplateNo", "==", this.template.storeTemplateNo)
      );
      const querySnapshot = await getDocs(q);
      await deleteDoc(doc(db, "storeTemplates", querySnapshot._docs[0].id));
      this.$snackbar.add(`刪除成功`, { color: "success" });
      this.desserts = [];
      await this.getStoreTemplates();
      this.closeDelete();
    },
    close() {
      const vm = this;
      this.logoFile = null;
      this.catchDeleteBranchIndex = null;
      this.mainPictureFile = [];
      this.subPictureFile = [];
      this.dialog = false;
      this.template = {};
      this.$nextTick(() => {
        vm.template = JSON.parse(JSON.stringify(vm.defaultItem));
        vm.editedIndex = -1;
        vm.$refs.form.reset();
      });
    },
    closeDelete() {
      const vm = this;
      this.dialogDelete = false;
      vm.template = {};
      this.$nextTick(() => {
        vm.template = JSON.parse(JSON.stringify(vm.defaultItem));
        vm.editedIndex = -1;
      });
    },
    onFileChange(event) {
      let files = event;
      if (JSON.stringify(files) !== "{}") return;
      if (Math.round(files.size, (Math / 1024) * 100) / 1000000 > 5) {
        alert("圖檔尺寸大於5MB，請壓縮後重新上傳");
        return;
      }
      if (this.mainPictureFile[this.upLoadingImgActive] && this.dialog) {
        this.template.storeTemplate[this.upLoadingImgActive].mainPictureUrl =
          URL.createObjectURL(this.mainPictureFile[this.upLoadingImgActive]);
      }
      if (this.subPictureFile[this.upLoadingImgActive] && this.dialog) {
        this.template.storeTemplate[this.upLoadingImgActive].subPictureUrl =
          URL.createObjectURL(this.subPictureFile[this.upLoadingImgActive]);
      }
      if (this.logoFile && this.dialog) {
        this.template.logoUrl = URL.createObjectURL(this.logoFile);
      }
    },
    async save(synchronous) {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          const q = query(
            collection(db, "storeTemplates"),
            where("storeTemplateNo", "==", this.template.storeTemplateNo)
          );
          const querySnapshot = await getDocs(q);
          if (this.logoFile) {
            let fileName = `logoFile.${this.getFileExtension(
              this.logoFile.type
            )}`;
            await uploadBytes(
              ref(
                storage,
                `/storeTemplates/${querySnapshot._docs[0].id}/${fileName}`
              ),
              this.logoFile
            ).then(async (snapshot) => {
              console.log("Uploaded a blob or file!(logo)", snapshot);
              await getDownloadURL(
                ref(
                  storage,
                  `/storeTemplates/${querySnapshot._docs[0].id}/${fileName}`
                )
              ).then((url) => {
                console.log(url);
                this.template.logoUrl = url;
              });
            });
          }
          if (!this.template.logoUrl) {
            this.template.logoUrl = "";
          }
          if (!this.template.memo) {
            this.template.memo = "";
          }
          if (!this.template.display) {
            this.template.display = false;
          }
          for (let i = 0; i < this.template.customAttributes.length; i++) {
            if (this.mainPictureFile[i]) {
              let fileName = `mainPictureFile${i}.${this.getFileExtension(
                this.mainPictureFile[i].type
              )}`;
              await uploadBytes(
                ref(
                  storage,
                  `/storeTemplates/${querySnapshot._docs[0].id}/${fileName}`
                ),
                this.mainPictureFile[i]
              ).then(async (snapshot) => {
                console.log("Uploaded a blob or file!(mainPicture)", snapshot);
                await getDownloadURL(
                  ref(
                    storage,
                    `/storeTemplates/${querySnapshot._docs[0].id}/${fileName}`
                  )
                ).then((url) => {
                  console.log(url);
                  this.template.customAttributes[i].mainPictureUrl = url;
                });
              });
            }
            if (this.subPictureFile[i]) {
              let fileName = `subPictureFile${i}.${this.getFileExtension(
                this.subPictureFile[i].type
              )}`;
              console.log(fileName);
              await uploadBytes(
                ref(
                  storage,
                  `/storeTemplates/${querySnapshot._docs[0].id}/${fileName}`
                ),
                this.subPictureFile[i]
              ).then(async (snapshot) => {
                console.log("Uploaded a blob or file!(subPicture)", snapshot);
                await getDownloadURL(
                  ref(
                    storage,
                    `/storeTemplates/${querySnapshot._docs[0].id}/${fileName}`
                  )
                ).then((url) => {
                  console.log(url);
                  this.template.customAttributes[i].subPictureUrl = url;
                });
              });
            }

            if (!this.template.customAttributes[i].display) {
              this.template.customAttributes[i].display = false;
            }
            if (!this.template.customAttributes[i].groupId) {
              this.template.customAttributes[i].groupId = "";
            }
            if (!this.template.customAttributes[i].storeIsInGroup) {
              this.template.customAttributes[i].storeIsInGroup = false;
            }
            if (this.template.customAttributes[i].storeIsInGroup == true) {
              if (!this.template.customAttributes[i].groupId) {
                this.template.customAttributes[i].storeIsInGroup = false;
                this.$snackbar.add(
                  `由於未填寫集團代碼，已將集團代表修改為false`,
                  { color: "error" }
                );
              }
            }
            if (!this.template.customAttributes[i].mainPictureUrl) {
              this.template.customAttributes[i].mainPictureUrl = "";
            }
            if (!this.template.customAttributes[i].subPictureUrl) {
              this.template.customAttributes[i].subPictureUrl = "";
            }
            if (!this.template.customAttributes[i].webSiteUrl) {
              this.template.customAttributes[i].webSiteUrl = "";
            }
          }
          await setDoc(
            doc(db, "storeTemplates", querySnapshot._docs[0].id),
            this.template
          );
        } else {
          let createdId = doc(collection(db, "env")).id;
          if (this.logoFile) {
            let fileName = `logoFile.${this.getFileExtension(
              this.logoFile.type
            )}`;
            console.log(fileName);
            await uploadBytes(
              ref(storage, `/storeTemplates/${createdId}/${fileName}`),
              this.logoFile
            ).then(async (snapshot) => {
              console.log("Uploaded a blob or file!(logo)", snapshot);
              await getDownloadURL(
                ref(storage, `/storeTemplates/${createdId}/${fileName}`)
              ).then((url) => {
                console.log(url);
                this.template.logoUrl = url;
              });
            });
          }
          if (!this.template.logoUrl) {
            this.template.logoUrl = "";
          }
          if (!this.template.memo) {
            this.template.memo = "";
          }
          if (!this.template.display) {
            this.template.display = false;
          }
          this.template.createTime = Number(this.timest());

          for (let i = 0; i < this.template.customAttributes.length; i++) {
            if (this.mainPictureFile[i]) {
              let fileName = `mainPictureFile${i}.${this.getFileExtension(
                this.mainPictureFile[i].type
              )}`;
              console.log(fileName);
              await uploadBytes(
                ref(storage, `/storeTemplates/${createdId}/${fileName}`),
                this.mainPictureFile[i]
              ).then(async (snapshot) => {
                console.log("Uploaded a blob or file!(mainPicture)", snapshot);
                await getDownloadURL(
                  ref(storage, `/storeTemplates/${createdId}/${fileName}`)
                ).then((url) => {
                  console.log(url);
                  this.template.customAttributes[i].mainPictureUrl = url;
                });
              });
            }
            if (this.subPictureFile[i]) {
              let fileName = `subPictureFile${i}.${this.getFileExtension(
                this.subPictureFile[i].type
              )}`;
              console.log(fileName);
              await uploadBytes(
                ref(storage, `/storeTemplates/${createdId}/${fileName}`),
                this.subPictureFile[i]
              ).then(async (snapshot) => {
                console.log("Uploaded a blob or file!(subPicture)", snapshot);
                await getDownloadURL(
                  ref(storage, `/storeTemplates/${createdId}/${fileName}`)
                ).then((url) => {
                  console.log(url);
                  this.template.customAttributes[i].subPictureUrl = url;
                });
              });
            }
            if (!this.template.customAttributes[i].display) {
              this.template.customAttributes[i].display = false;
            }
            if (!this.template.customAttributes[i].groupId) {
              this.template.customAttributes[i].groupId = "";
            }
            if (!this.template.customAttributes[i].storeIsInGroup) {
              this.template.customAttributes[i].storeIsInGroup = false;
            }
            if (this.template.customAttributes[i].storeIsInGroup == true) {
              if (!this.template.customAttributes[i].groupId) {
                this.template.customAttributes[i].storeIsInGroup = false;
                this.$snackbar.add(
                  `由於未填寫集團代碼，已將集團代表修改為false`,
                  { color: "error" }
                );
              }
            }
            if (!this.template.customAttributes[i].mainPictureUrl) {
              this.template.customAttributes[i].mainPictureUrl = "";
            }
            if (!this.template.customAttributes[i].subPictureUrl) {
              this.template.customAttributes[i].subPictureUrl = "";
            }
            if (!this.template.customAttributes[i].webSiteUrl) {
              this.template.customAttributes[i].webSiteUrl = "";
            }
            // if (this.desserts.length == 0) {
            //   this.template.customAttributes[i].storeNo = 1;
            // } else {
            //   this.template.customAttributes[i].storeNo = (
            //     Math.max(...this.desserts.map((p) => Number(p.storeNo))) + 1
            //   ).toString();
            // }
            if (this.desserts.length == 0) {
              this.template.storeTemplateNo = 1;
            } else {
              this.template.storeTemplateNo = (
                Math.max(
                  ...this.desserts.map((p) => Number(p.storeTemplateNo))
                ) + 1
              ).toString();
            }
            this.template.customAttributes[i].storeNo = "尚未取號";
            this.template.customAttributes[i].count = 0;
            this.template.expired = false;
          }
          await setDoc(doc(db, "storeTemplates", createdId), this.template);
        }
        this.logoFile = null;
        this.mainPictureFile = [];
        this.subPictureFile = [];

        this.desserts = [];
        await this.getStoreTemplates();
        this.$snackbar.add(`修改完成`, { color: "success" });
        if (synchronous) {
          this.synchronous();
        } else {
          this.close();
        }
      }
    },
    async synchronous() {
      const vm = this;
      try {
        // 遍歷 customAttributes
        for (let i = 0; i < vm.template.customAttributes.length; i++) {
          const attr = vm.template.customAttributes[i];
          try {
            const count =
              attr.storeNo !== "尚未取號"
                ? await vm.getStoreCount(attr.storeNo)
                : 0;
            vm.template.customAttributes[i].count = count;

            // 如果 storeNo 是 "尚未取號" 才進行新增號碼
            if (attr.storeNo === "尚未取號") {
              const storeNo = await vm.getUpdatedStoreNo();
              vm.template.customAttributes[i].storeNo = storeNo;
              let createdId = doc(collection(db, "env")).id;
              await setDoc(doc(db, "stores", createdId), {
                actType: vm.template.actType,
                address: vm.template.customAttributes[i].address,
                city: vm.template.customAttributes[i].city,
                createTime: vm.template.createTime,
                description: vm.template.description,
                endDate: vm.template.endDate,
                expired: vm.template.expired,
                lat: vm.template.customAttributes[i].lat,
                lng: vm.template.customAttributes[i].lng,
                logoUrl: vm.template.logoUrl,
                mainPictureUrl: vm.template.customAttributes[i].mainPictureUrl,
                memo: vm.template.memo,
                phone: vm.template.customAttributes[i].phone,
                startDate: vm.template.startDate,
                storeName: vm.template.customAttributes[i].storeName,
                subPictureUrl: vm.template.customAttributes[i].subPictureUrl,
                title: vm.template.title,
                webSiteUrl: vm.template.customAttributes[i].webSiteUrl,
                groupId: vm.template.customAttributes[i].groupId,
                display: vm.template.customAttributes[i].display,
                storeIsInGroup: vm.template.customAttributes[i].storeIsInGroup,
                count: count,
                storeNo: storeNo,
              });
              console.log("同步新增");
            } else {
              // 修改
              const storeNo = attr.storeNo;
              vm.template.customAttributes[i].storeNo = storeNo;
              const q = query(
                collection(db, "stores"),
                where("storeNo", "==", storeNo)
              );
              const querySnapshot = await getDocs(q);
              if (querySnapshot.empty) {
                const storeNo = await vm.getUpdatedStoreNo();
                vm.template.customAttributes[i].storeNo = storeNo;
                let createdId = doc(collection(db, "env")).id;
                await setDoc(doc(db, "stores", createdId), {
                  actType: vm.template.actType,
                  address: vm.template.customAttributes[i].address,
                  city: vm.template.customAttributes[i].city,
                  createTime: vm.template.createTime,
                  description: vm.template.description,
                  endDate: vm.template.endDate,
                  expired: vm.template.expired,
                  lat: vm.template.customAttributes[i].lat,
                  lng: vm.template.customAttributes[i].lng,
                  logoUrl: vm.template.logoUrl,
                  mainPictureUrl:
                    vm.template.customAttributes[i].mainPictureUrl,
                  memo: vm.template.memo,
                  phone: vm.template.customAttributes[i].phone,
                  startDate: vm.template.startDate,
                  storeName: vm.template.customAttributes[i].storeName,
                  subPictureUrl: vm.template.customAttributes[i].subPictureUrl,
                  title: vm.template.title,
                  webSiteUrl: vm.template.customAttributes[i].webSiteUrl,
                  groupId: vm.template.customAttributes[i].groupId,
                  display: vm.template.customAttributes[i].display,
                  storeIsInGroup:
                    vm.template.customAttributes[i].storeIsInGroup,
                  count: count,
                  storeNo: storeNo,
                });
                console.log("查無店家-同步新增");
              } else {
                await setDoc(doc(db, "stores", querySnapshot._docs[0].id), {
                  actType: vm.template.actType,
                  address: vm.template.customAttributes[i].address,
                  city: vm.template.customAttributes[i].city,
                  createTime: vm.template.createTime,
                  description: vm.template.description,
                  endDate: vm.template.endDate,
                  expired: vm.template.expired,
                  lat: vm.template.customAttributes[i].lat,
                  lng: vm.template.customAttributes[i].lng,
                  logoUrl: vm.template.logoUrl,
                  mainPictureUrl:
                    vm.template.customAttributes[i].mainPictureUrl,
                  memo: vm.template.memo,
                  phone: vm.template.customAttributes[i].phone,
                  startDate: vm.template.startDate,
                  storeName: vm.template.customAttributes[i].storeName,
                  subPictureUrl: vm.template.customAttributes[i].subPictureUrl,
                  title: vm.template.title,
                  webSiteUrl: vm.template.customAttributes[i].webSiteUrl,
                  groupId: vm.template.customAttributes[i].groupId,
                  display: vm.template.customAttributes[i].display,
                  storeIsInGroup:
                    vm.template.customAttributes[i].storeIsInGroup,
                  count: count,
                  storeNo: storeNo,
                });
                console.log("同步修改");
              }
            }
          } catch (error) {
            console.error(`Error in synchronousTemplate at index ${i}:`, error);
          }
        }
        this.editedIndex = 0;
        vm.save();
        await vm.updateToApp();
      } catch (error) {
        console.error("Error in synchronous function: ", error);
      }
    },
    getFileExtension(filename) {
      return filename.slice(((filename.lastIndexOf("/") - 1) >>> 0) + 2);
    },
    getItemId(item) {
      return item.storeTemplateNo; // Must be uid of record (would be nice if v-data-table exposed a "getItemKey" method)
    },
    toggleExpand(props) {
      const item = props.item;
      const id = this.getItemId(item);
      if (props.isExpanded && this.transitioned[id]) {
        // If we're expanded and not in the process of closing, close
        this.closeExpand(item);
      } else {
        // If we're closed or in the process of closing, expand
        // Stop us from closing if a close transition was started
        clearTimeout(this.closeTimeouts[id]);
        // Tell v-data-table to add the expansion content for the item
        props.expand(true);
        // Show expansion content with transition animation after it's had time to get added to the DOM
        this.$nextTick(() => this.$set(this.transitioned, id, true));
        // Hide all other expanded items if single-expand
        if (this.singleExpand)
          this.$nextTick(() =>
            this.expanded.forEach((i) => i !== item && this.closeExpand(i))
          );
      }
    },
    closeExpand(item) {
      const id = this.getItemId(item);
      // Mark that this item is in the process of closing
      this.$set(this.transitioned, id, false);
      // Remove expansion content from DOM after transition animation has had enough time to finish
      this.closeTimeouts[id] = setTimeout(
        () => this.$refs.vDataTable.expand(item, false),
        600
      );
    },
    timest() {
      var tmp = Date.parse(new Date()).toString();
      tmp = tmp.substr(0, 10);
      return tmp;
    },
    dateRules(endDate, startDate) {
      let array = [];
      array[0] = endDate ? true : "結束日期為必填項目";
      array[1] =
        Math.floor(new Date(endDate).getTime() / 1000) >
        Math.floor(new Date(startDate).getTime() / 1000)
          ? true
          : "結束日期必須大於起始日期";
      return array;
    },
    handleScroll() {
      // console.log(
      //   window.scrollY,
      //   window.screen.height,
      //   document.body.scrollHeight
      // );
      this.offsetTop = window.scrollY;
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    async updateToApp() {
      const querySnapshot = await getDocs(collection(db, "stores"));
      querySnapshot.forEach((doc) => {
        this.allStrores.push(doc.data());
        this.allStrores.sort((a, b) => {
          return b.storeNo - a.storeNo;
        });
      });
      let storeIndexList = [];
      this.allStrores.forEach((item) => {
        if (!item.expired) {
          storeIndexList.push({
            description: `${item.title}${item.description}${item.memo}`,
            storeName: item.storeName,
            storeNo: item.storeNo,
            actType: item.actType,
            city: item.city,
            groupId: item.groupId,
          });
        }
      });
      console.log(storeIndexList);
      await setDoc(doc(db, "storeIndexList", "storeIndexList"), {
        indexList: storeIndexList,
      });
      this.$snackbar.add(`已更新至APP`, { color: "success" });
    },
  },
};
</script>
<style scoped>
::v-deep .v-dialog:not(.v-dialog--fullscreen) {
  max-height: 96%;
}
.my-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.my-scrollbar::-webkit-scrollbar-track {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}

.my-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #727272;
}

.my-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #3a3a3a;
}

.my-scrollbar::-webkit-scrollbar-thumb:active {
  background: #3a3a3a;
}
</style>
